import { c as _c } from "react/compiler-runtime";
import { cloneElement, isValidElement } from "react";
import type { ReactElement } from "react";
import { MenuButton } from "@headlessui/react";
import clsx from "clsx";
import type { CompactMenuProps } from "../types";
import { DEFAULT_TRIGGER_CLASSES } from "../constants";
interface CompactMenuTriggerProps {
  readonly trigger: CompactMenuProps["trigger"];
  readonly triggerClassName?: string;
  readonly unstyledTrigger?: boolean;
  readonly disabled?: boolean;
  readonly ariaLabel?: string;
  readonly isOpen: boolean;
  readonly close: () => void;
}
export function CompactMenuTrigger(t0) {
  const $ = _c(14);
  const {
    trigger,
    triggerClassName,
    unstyledTrigger: t1,
    disabled: t2,
    ariaLabel,
    isOpen,
    close
  } = t0;
  const unstyledTrigger = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== close || $[1] !== isOpen || $[2] !== trigger) {
    t3 = () => {
      if (typeof trigger === "function") {
        return trigger({
          isOpen,
          close
        });
      }
      if (isCustomTriggerElement(trigger)) {
        return cloneElement(trigger, {
          isOpen,
          close
        });
      }
      return trigger;
    };
    $[0] = close;
    $[1] = isOpen;
    $[2] = trigger;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const renderTrigger = t3;
  const t4 = unstyledTrigger ? undefined : DEFAULT_TRIGGER_CLASSES;
  let t5;
  if ($[4] !== t4 || $[5] !== triggerClassName) {
    t5 = clsx(t4, triggerClassName);
    $[4] = t4;
    $[5] = triggerClassName;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== renderTrigger) {
    t6 = renderTrigger();
    $[7] = renderTrigger;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== ariaLabel || $[10] !== disabled || $[11] !== t5 || $[12] !== t6) {
    t7 = <MenuButton type="button" aria-label={ariaLabel} disabled={disabled} className={t5}>{t6}</MenuButton>;
    $[9] = ariaLabel;
    $[10] = disabled;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
type TriggerRenderProps = {
  isOpen: boolean;
  close: () => void;
};
const isCustomTriggerElement = (element: CompactMenuProps["trigger"]): element is ReactElement<TriggerRenderProps> => isValidElement(element) && typeof element.type !== "string";